
<div class="header" [ngStyle]="{backgroundImage: 'url(' + tournament.previewImage.path + ')'}">
  <div class="info">
    <div class="name">{{ tournament.name }}</div>
    <div class="params">
      {{ tournament.settings.genderTitle }} {{ tournament.settings.birthYearFrom }}-{{ tournament.settings.birthYearTo }}
      <span> • </span>
      <ng-container *ngIf="tournament.settings.maxGamePlayers === tournament.settings.maxTeamPlayers">
        {{ tournament.settings.maxTeamPlayers }} {{ tournament.settings.maxTeamPlayers | pluralize: ['игрок', 'игрока', 'игроков']}}
      </ng-container>
      <ng-container *ngIf="tournament.settings.maxGamePlayers !== tournament.settings.maxTeamPlayers">
        {{ tournament.settings.maxGamePlayers }}-{{ tournament.settings.maxTeamPlayers }} игроков
      </ng-container>
    </div>
  </div>
  <a [routerLink]="getTournamentRoute()" class="btn-detail">Перейти</a>
</div>

<div class="teams">
  <div class="team second-place">
    <a [routerLink]="getTeamRoute(tournament.teamSecond.team.id)" [queryParams]="{season_id: tournament.season.id}" class="logo">
      <mtg-svg-icon class="award-left" icon="custom-award-left"></mtg-svg-icon>
      <img [src]="tournament.teamSecond.team.logo.path">
      <mtg-svg-icon class="award-right" icon="custom-award-right"></mtg-svg-icon>
    </a>
    <div class="name">
      <a [routerLink]="getTeamRoute(tournament.teamSecond.team.id)" [queryParams]="{season_id: tournament.season.id}">
        <div class="bold">2 место</div>
        {{ tournament.teamSecond.team.name }}
      </a>
    </div>
  </div>
  <div class="team first-place">
    <a [routerLink]="getTeamRoute(tournament.teamWinner.team.id)" [queryParams]="{season_id: tournament.season.id}" class="logo">
      <mtg-svg-icon class="award-left" icon="custom-award-left"></mtg-svg-icon>
      <img [src]="tournament.teamWinner.team.logo.path">
      <mtg-svg-icon class="award-right" icon="custom-award-right"></mtg-svg-icon>
      <div class="trophy"></div>
    </a>
    <div class="name">
      <a [routerLink]="getTeamRoute(tournament.teamWinner.team.id)" [queryParams]="{season_id: tournament.season.id}">
        <div class="bold">1 место</div>
        {{ tournament.teamWinner.team.name }}
      </a>
    </div>
  </div>
  <div class="team third-place">
    <a [routerLink]="getTeamRoute(tournament.teamThird.team.id)" [queryParams]="{season_id: tournament.season.id}" class="logo">
      <mtg-svg-icon class="award-left" icon="custom-award-left"></mtg-svg-icon>
      <img [src]="tournament.teamThird.team.logo.path">
      <mtg-svg-icon class="award-right" icon="custom-award-right"></mtg-svg-icon>
    </a>
    <div class="name">
      <a [routerLink]="getTeamRoute(tournament.teamThird.team.id)" [queryParams]="{season_id: tournament.season.id}">
        <div class="bold">3 место</div>
        {{ tournament.teamThird.team.name }}
      </a>
    </div>
  </div>
</div>
